import { internalCloseSxS } from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';
import sxsStore from '../store/Store';
import { mutator } from 'satcheljs';

mutator(showSxS, () => {
    if (!sxsStore.shouldShow) {
        sxsStore.shouldShow = true;
        sxsStore.sessionStartTime = new Date().getTime();
    }

    sxsStore.sessionPreviewCount++;
});

mutator(internalCloseSxS, () => {
    sxsStore.shouldShow = false;
    sxsStore.sessionPreviewCount = 0;
});
